<ik-modal (OnClose)="dialogRef.close()">
    <ng-container header>
        {{'Profils de paiement' | transloco}}
    </ng-container>
    
    <ng-container main>
        <div class="description">
            {{'Veuillez selectionner le profil de paiement par defaut.' | transloco}}
        </div>
        
        <div class="profiles">
            <div *ngFor="let profile of data.paiementProfiles"
            class="profile">
            <ng-container *ngIf="profile.details_type === 'card'">
                <div class="profile__icon">
                    <img [src]="profile.iconUrl"
                    [alt]="'Carte de credit' | transloco" />
                </div>
                <div class="profile__content">
                    <div class="profile__title">
                        **** **** **** {{profile.details.last4}}
                    </div>
                    <div class="profile__expiration">
                        <span>{{'Expiration' | transloco}} {{profile.details.expiry_month}}/{{profile.details.expiry_year}}</span>
                </div>
                <div class="profile__selection">
                    <mat-checkbox class="checkbox-rounded"
                    [checked]="selectedProfile.id === profile.id"
                    (change)="onSelectProfile($event, profile)"
                    color="primary">
                </mat-checkbox>

                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="profile.details_type === 'prepaid'">
                <div class="profile__icon">
                    <img [src]="profile.iconUrl"
                    [alt]="'Compte prepaye' | transloco" />
                </div>
                <div class="profile__content">
                <div class="profile__title">
                    {{'Compte prepaye' | transloco}}
                </div>
            <div class="profile__expiration">
                <span>{{'Solde :' | transloco}} {{profile.details.amount}}</span>
                </div>
                <div class="profile__selection">
                <mat-checkbox class="checkbox-rounded"
                [checked]="selectedProfile.id === profile.id"
                (change)="onSelectProfile($event, profile)"
                color="primary">
            </mat-checkbox>
            </div>
        </div>
    </ng-container>
    
</div>
</div>
</ng-container>

<ng-container footer>
    <button mat-flat-button
    mat-dialog-close
    [attr.aria-label]="'Annuler' | transloco"
    color="accent">
    {{ 'Annuler' | transloco }}
</button>

<button mat-flat-button
color="primary"
(click)="save()"
[buttonLoader]="loading">
{{ 'Enregistrer' | transloco }}
</button>
</ng-container>
</ik-modal>
